import { combineReducers } from 'redux'

import edit from './edit'
import upload from './upload'

export default combineReducers({
  edit,
  upload,
})
